import { useContext } from "react";
import { numberWithCommas } from "../utils/util";
import BlockchainContext from "../store/BlockchainContext";

const WelcomeSection = () => {
  const { totalDeposit, totalRefEarn, usdPrice } =
    useContext(BlockchainContext);
  return (
    <section className="panel_section">
      <div className="container">
        <div className="row">
          <div className="col-md-12 col-12">
            <div className="panel mb-5">
              <div className="row">
                <div className="col-md-4 col-12 text-center">
                  <h2>{numberWithCommas(totalDeposit, 5)} MATIC</h2>
                  <h5>~ ${numberWithCommas(totalDeposit * usdPrice, 2)}</h5>
                  <p className="mb-0">Total Deposited Value</p>
                </div>
                <div className="col-md-4 col-12 text-center">
                  <h2>{numberWithCommas(totalDeposit, 5)} MATIC</h2>
                  <h5>~ ${numberWithCommas(totalDeposit * usdPrice, 2)}</h5>
                  {/* <h2>{numberWithCommas(totalDeposit - 1386, 5)} MATIC</h2>
                  <h5>
                    ~ ${numberWithCommas((totalDeposit - 1386) * usdPrice, 2)}
                  </h5> */}
                  <p className="mb-0">Active Investments</p>
                </div>
                <div className="col-md-4 col-12 text-center">
                  <h2>{numberWithCommas(totalRefEarn, 5)} MATIC</h2>
                  <h5>~ ${numberWithCommas(totalRefEarn * usdPrice, 2)}</h5>
                  <p className="mb-0">Total Referral Earnings</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WelcomeSection;
